export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_9-f2a13029d9c9654c38c25853ed713c82.svg";